import ReactSelectAsync from 'react-select/async';
import classNames from 'classnames';

import { InputLabel } from '@ui/InputLabel';
import { FormError } from '@ui/FormError';

import { SelectAsyncProps, GroupBase } from '../../types';
import { getDefaultProps } from '../../utils';

import s from './SelectAsync.sss';

export function SelectAsync<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
>({
  required,
  ...props
}: SelectAsyncProps<Option, IsMulti, Group>) {
  const {
    className,
    label,
    error,
    helpText,
    inputClassName,
  } = props;

  const defaultProps = getDefaultProps(props);

  return (
    <div
      className={classNames(
        s.root,
        className,
      )}
    >
      {label
        && (
        <InputLabel
          className={s.label}
          required={required}
        >
          {label}
        </InputLabel>
        )}

      <ReactSelectAsync
        {...defaultProps}
        {...props}
        className={classNames(s.input, inputClassName)}
      />

      {helpText && <div className={s.helpText}>{helpText}</div>}
      {error && (
        Array.isArray(error)
          ? error.map((e, i) => <FormError key={i}>{e}</FormError>)
          : <FormError>{error}</FormError>
      )}
    </div>
  );
}
